import type { SchoolTypeEnum } from "@/providers/store/api/reports/reports.interface";

export type BoundarySchoolSelectVariant = "listbox" | "grouped" | "searchable";

export interface BuildBoundaryDistrictSchoolsQueryArgsInput {
  districtId: string;
  schoolSelectVariant: BoundarySchoolSelectVariant;
  isBoundariesEditMode: boolean;
  editingSchoolType: SchoolTypeEnum | null;
}

export interface BoundaryDistrictSchoolsQueryArgs {
  districtId: string;
  includeScheduledOpening?: true;
  schoolTypes?: SchoolTypeEnum[];
}

export function buildBoundaryDistrictSchoolsQueryArgs({
  districtId,
  schoolSelectVariant,
  isBoundariesEditMode,
  editingSchoolType,
}: BuildBoundaryDistrictSchoolsQueryArgsInput): BoundaryDistrictSchoolsQueryArgs {
  const base: BoundaryDistrictSchoolsQueryArgs = {
    districtId,
    ...(isBoundariesEditMode ? { includeScheduledOpening: true as const } : {}),
  };

  const shouldFilterByEditingSchoolType =
    (schoolSelectVariant === "listbox" || schoolSelectVariant === "searchable") &&
    isBoundariesEditMode &&
    editingSchoolType;

  if (shouldFilterByEditingSchoolType) {
    return { ...base, schoolTypes: [editingSchoolType] };
  }

  return base;
}
